import { useEffect, useRef, useState } from 'react'

export function useParallax(speed: number = 0.2) {
  const ref = useRef<HTMLDivElement>(null)
  const [offset, setOffset] = useState(0)

  useEffect(() => {
    let animationFrameId: number
    let lastScrollY = window.scrollY

    const handleScroll = () => {
      if (!ref.current) return

      const rect = ref.current.getBoundingClientRect()
      const elementTop = rect.top + window.scrollY
      const viewportHeight = window.innerHeight

      // Only calculate if element is in or near viewport
      if (
        window.scrollY + viewportHeight > elementTop - 500 &&
        window.scrollY < elementTop + rect.height + 500
      ) {
        // Calculate distance from center of viewport
        const distanceFromCenter =
          rect.top + rect.height / 2 - viewportHeight / 2
        setOffset(distanceFromCenter * speed)
      }

      lastScrollY = window.scrollY
      animationFrameId = requestAnimationFrame(handleScroll)
    }

    // Initial calculation
    handleScroll()

    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
      cancelAnimationFrame(animationFrameId)
    }
  }, [speed])

  return {
    ref,
    style: { transform: `translateY(${offset}px)` },
  }
}
